//Credit to vank0 @ codepen
import './loader.css';

export const LoaderAnimation = () => {
    return (
        <div className="loader-container">
            <div className="loader-38"/>
        </div>
    )
}